import React, { useState } from 'react';
import './modal.css';


interface ModalProps {
  children: React.ReactNode,
  title: string,
  primaryButtonText: string,
  primaryButtonClick: () => void,
  secondaryButtonText: string,
  secondaryButtonClick?: () => void
}
export function Modal(props: ModalProps) {

  return (
    <div className='outside' >
      <div className='container'>
        <h1 className='title'>{props.title}</h1>
        <div className='children'>
          {props.children}
        </div>
        <div className='button-container'>
          <button className='button' onClick={props.secondaryButtonClick}>{props.secondaryButtonText}</button>
          <button className='button' onClick={props.primaryButtonClick}>{props.primaryButtonText}</button>
        </div>
      </div>
    </div>
  )
}